var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuotationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 26,
    viewBox: "0 0 35 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6289 25.8691C31.251 25.8691 34.9979 22.1221 34.9979 17.5C34.9979 14.0861 33.2207 10.7828 30.5682 10.1454C29.5451 9.89956 28.7302 8.58654 28.9053 7.08761C29.1396 5.08134 30.9539 3.05439 34.5462 1.45706C35.3461 1.1014 35.0112 -0.101814 34.1426 0.0069294C24.7805 1.17904 18.291 7.28249 18.2599 15.9178C18.2598 21.8564 21.7684 25.8691 26.6289 25.8691Z",
    fill: "url(#paint0_linear_33_63)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36897 25.8691C12.9911 25.8691 16.7381 22.1221 16.7381 17.5C16.7381 14.086 14.9609 10.7828 12.3083 10.1454C11.2852 9.89953 10.4703 8.58651 10.6454 7.08758C10.8798 5.08131 12.6941 3.05436 16.2864 1.45703C17.0862 1.10137 16.7513 -0.101845 15.8827 0.00689888C6.52065 1.17901 0.031133 7.28246 2.68758e-09 15.9177C-0.000112128 21.8564 3.5085 25.8691 8.36897 25.8691Z",
    fill: "url(#paint1_linear_33_63)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_63",
    x1: 18.2599,
    y1: 12.9346,
    x2: 35,
    y2: 12.9346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#284555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ABCC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_63",
    x1: 0,
    y1: 12.9345,
    x2: 16.7401,
    y2: 12.9345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#284555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ABCC5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationIcon);
export default __webpack_public_path__ + "static/media/quotation-icon.67d37569be7e85cefdc568a69e6c60fc.svg";
export { ForwardRef as ReactComponent };